(function(d){d.fn.shuffle=function(c){c=[];return this.each(function(){c.push(d(this).clone(true))}).each(function(a,b){d(b).replaceWith(c[a=Math.floor(Math.random()*c.length)]);c.splice(a,1)})};d.shuffle=function(a){return d(a).shuffle()}})(jQuery);
teafinder.clickEvent = function(){

  //tea-email-popup
  $(document).on("click",".tea-email-popup .close",function(){
    $('.tea-email-popup').hide();
  });

  //quick-view


  // shipping_details
  teafinder.shippinDetails = function(){

    var cc_code = $('#dv-flag-holder').data('country-id');
    if(cc_code){
     var cc_up = cc_code.toUpperCase();
   }
   var price = $(".pdt-sp-price>span").attr("data-base-amount");
   $.ajax({
     url: 'https://apps.teabox.com/shipping/get_delivery_date/',
     type: 'POST',
     dataType: 'json',
     data:{
       "country": cc_up,
       "price": price,
       "currency": "INR"
     },
     success: function(data) {
       $(".ForDelDate").remove();

       $(".address_section").append('<p class="ForDelDate">Ships in 24 Hours. </br>Delivers to <span class="ship-loc"><u></u></span> by <span class="dil-date"></span></p>');
       $( ".ForDelDate" ).insertBefore( ".view-PrdRv" );
       $(".ship-loc u").html(data.country);
       $(".dil-date").html(data.delivers_by);
       $('.pdt-ship-cnt').show(); 
 // $('.quick-popup-inner-right-address').show();
}
});
 };

  //product swatches
  $(document).on("click","#quick_view .swatch-element",function(){

   teafinder.productSwatchesChange($(this), true);
 });

  //spinner
  $(document).on("click",".spinner .plus",function(){
    var target = $(this).siblings("input");
    var value = parseInt(target.val()) + 1;
    target.val(value);
  });
  $(document).on("click",".spinner .min",function(){
    var target = $(this).siblings("input");
    var value = parseInt(target.val());
    if(value > 0){
      var value = value - 1;
      target.val(value);
    }
  });

  $(document).on("click",".quick-popup-main .product-close",function(event) { 

    $(".quick-popup-main").hide();
  });

  $(".skip_email").click(function(event) {
    var emailCheck = $(".customer_info .email_input").val();
    if(cn(emailCheck)){
      $(".email_wrap").attr("data-selected","skip");
      teafinder.setObjData();
      teafinder.showResult();  
    }
    else{
      $(".customer_info").submit();
    }
  });


  $(".good_to_go").click(function(event) {
    if(tea.email != 'skip' && !cn(tea.email)){
      teafinder.showLoading();
      var p_array =  [];
      var handle_string = "";
      teafinder.setCookie("teafinder","true",1);
      $(".final_result .single_product").each(function(index, el) {
        var obj = {};
        handle_string = handle_string +  $(el).attr("data-phandle") + ",";
        obj.handle =  $(el).attr("data-phandle");
        obj.title =  $(el).attr("data-ptitle");
        obj.image =  $(el).attr("data-pimage");
        obj.price = $(el).attr("data-pprice");
        p_array.push(obj);
      });
      $('.result_wrap .tea-email-popup').hide();
      var products_form = $(".customer_product_form");
      $(".customer_product",products_form).val(handle_string);
      $(".customer_product_json",products_form).val(JSON.stringify(p_array));
      $(".email_input",products_form).val(tea.email);
      teafinder.formSubmit(products_form,teafinder.goToHome);  
    }
    else{
      // teafinder.goToHome();
      teafinder.setCookie("teafinder","true",1);
      $('.result_wrap .tea-email-popup').show();
    }
  }); 
  $(".tags_wrapper .li").click(function(event) {
    $(".sort_by a span").text($(this).text());
    $(".tags_wrapper .li").removeClass('active');
    var findTag = $(this).attr("data-value");
    $(this).addClass('active');
    if(findTag == 'all'){
      $(".final_result .single_product").removeClass('hide').addClass("show").show();
    }
    else{
      $(".final_result .single_product").each(function(index, el) {
        var tagArray = $(this).attr("data-tags");
        tagArray = tagArray.split(",");
        if($.inArray( findTag, tagArray ) == -1){
          $(el).hide().addClass("hide").removeClass("show");
        }
        else{
          $(el).show().removeClass('hide').addClass('show'); 
        }
      });  

    }
    var shownLength = $(".final_result .single_product.show").length;
    var nodata = $(".result_wrap .no_data");
    $(".result_count").html(shownLength);
    if($(".final_result .single_product").length == $(".final_result .single_product.hide").length){
      nodata.show();
      $(".result_main_wrapper").hide();
      $(".good_to_go_wrap").hide();
      $(".button_fixed_wrapper").css('position','fixed');
      $(".button_fixed_wrapper").css("padding-top","90px");
  

    }
    else{
      $(".result_main_wrapper").show();
      $(".good_to_go_wrap").show();
      nodata.hide();
      $(".button_fixed_wrapper").css('position','relative');
            $(".button_fixed_wrapper").css("padding-top","15px");
    }

  });
  $(".reset_p a").click(function(event) {
    $(".result_wrap").hide();
    teafinder.hideHeader();
    $(".section_wrapper").fadeIn();
    teafinder.changeStep(1);
  });
  $(".tea_header .sort_by").click(function(event) {
    $(".tags_wrapper").stop().slideToggle();
    $("i",this).toggleClass("fa-angle-up fa-angle-down");
  });
  $(".get_started,.store_loaction_open").click(function(event) {
    // $(".tea-store").fadeIn();  
    $(".intro_page").hide();
    $(".tea-store").hide();  
    $(".section_wrapper").fadeIn(); 
    teafinder.setObjData();
  });
  $(".tea-store .close_btn").click(function(event) {
    $(".tea-store").fadeOut();  
  });  
  $(".tea_header .step").click(function(event) {
    var data_index = $(this).attr("data-index");
    if($(this).hasClass('reached')){
      var target = $(this).attr("data-index");
      teafinder.changeStep(target);
      teafinder.setObjData();
    }
    var data_index = $(this).attr("data-index");
    if(data_index == 4 || data_index == '4'){
      if($('.logged_customer_checker').length > 0 ){
        var logged_email = $('.logged_customer_checker').text();
        $('.customer_info .email_input').val(logged_email);
        $('.email_block .skip_email').click();
      }
    }
  });
  $(".tea-store .single_store").click(function(event) {
    if(tea.location){
      tea.location = $(this).attr("data-name");
      teafinder.showResult();
    }
    else{
      var parent = $(this).closest('.tea_store_section');  
      $(".tea-store .single_store",parent).removeClass('active');
      $(this).addClass("active"); 
      $(".tea-store .next").click();  
    }

  });

  $(document).on("click",".tea-store .buttons",function(event) { 
    $(".intro_page").hide();
    $(".tea-store").hide();  
    $(".section_wrapper").fadeIn(); 
    teafinder.setObjData();
  });

  $(".options .single_option").click(function(event) {
    event.stopPropagation();
    var parent = $(this).closest('.section');
    $(".next .svg_icon",parent).addClass('colored');
    if(parent.hasClass("flavor_wrap")){
      $(this).toggleClass("active");  
      var flavor = "";
      var total_l = $(".single_option.active",parent).length;
      $(".single_option.active",parent).each(function(index, el) {
        index = index + 1;
        var slection = $(".text",this).attr("data-text");
        if(index == total_l){
          flavor = flavor +slection;
        }
        else{
          flavor = flavor+slection +",";
        }
      });
      parent.attr("data-selected",flavor);
    }
    else{
      $(".options .single_option",parent).removeClass('active');  
      $(this).addClass("active");
      var selection = $(".text",this).attr("data-text");
      parent.attr("data-selected",selection);
    }
  });

  $(".buttons a").click(function(event) {
    var next = false; 
    var target;
    var current = parseInt($(this).attr("data-index"));
    if($(this).hasClass('next')){
      next = true;
    }
    var goCheck = $(".section.section_"+current).attr("data-selected");
    if(!cn(goCheck) && next){
      target = $(this).attr("data-next");
      $(".step.step_"+current).addClass('reached');
      teafinder.setObjData();
      teafinder.changeStep(target);  
    }
    if(!next){
      target = $(this).attr("data-prev");  
      teafinder.setObjData();
      teafinder.changeStep(target);  
    }
  });
};
teafinder.showHeader = function(){
  if($(window).width() > 1024){
    $(".whole_header").show();  
  }
  
};
teafinder.hideHeader = function(){
  $(".whole_header").hide();
};
teafinder.showResult = function(form){
  teafinder.showHeader();
  $("body").removeClass("p_bg");
  $(".step.step_4").addClass("reached");
  teafinder.showLoading('text');
  $(".section_wrapper").hide();
  var href = '/collections/tea/';
  var final_tags = "";
  
  for(key in tea){
    if(key != 'flavor' && key != 'email' && key != 'wishlist'){
      if(!cn(tea[key])){
        if(key =='location'){

          if(teafinder.queryString().location)
            final_tags = final_tags + tea[key] + "+";
        }else{
          final_tags = final_tags + tea[key] + "+";
        }
        
      }
    }
  }
  href = href + final_tags;
  tempFlvor = [];
  for(var i=0;i<tea['flavor'].length;i++){
    tempFlvor[i] = tea['flavor'][i];
  }
  $(".result_wrap .final_result").html("");
  teafinder.getCollectionData(href,tempFlvor,form);

}
teafinder.getCollectionData = function(href,fArray,form,replacedHref){
  var parent = $(".result_wrap");
  if(fArray.length > 0){
    var flv = fArray.pop();
    var newHref;
    if(cn(replacedHref)){
      newHref = href +flv+ "?view=tea";  
    }
    else{
     newHref = replacedHref +flv+ "?view=tea";   
   }
   $.get(newHref,function(data){
    data = $(data);
    $(".single_product",data).attr("data-ftype",flv);
    if($(".single_product",data).length == 0  && cn(replacedHref)){
      fArray.push(flv);
      replacedHref = href.replace("tf-connoisseur","tf-enthusiast");
      replacedHref = replacedHref.replace("tf-novice","tf-enthusiast");
      teafinder.getCollectionData(href,fArray,form,replacedHref);
      return false; 
    }
    $(".final_result",parent).append($(".single_product",data));

    $(".content_wrap img").each(function(index, el) {
      var image = new Image();
      if($(window).width()>767){
        $(el).parent().attr('target', '_blank');
      }
      image.onload = function(){
        if ($(window).width() > 767){
          teafinder.miniHeight(".single_product .h3 ",".single_product .h3 h3");   
          teafinder.miniHeight(".single_product .content ",".single_product .content_wrap"); 
        }
      }; 
      image.src = $(el).attr("src");
    });
    teafinder.hideLoading();
    if(cn(form)){
      teafinder.getCollectionData(href,fArray);
    }
    else{
      teafinder.getCollectionData(href,fArray,form);
    }
  });
 }
 else{
  $(".final_result .single_product").shuffle();
  var tempArray = ["tf-floral", "tf-fruity", "tf-spicy", "tf-vegetal", "tf-woody"];
  var finalArray = [];

  result_count = $(".final_result .single_product").length;
  var whileResult = result_count;

  if (result_count > 9){
    var $tempStore = $("<div class='temp_store'>");
    var resultTotal = $tempStore.children().length;
    while(resultTotal < 9){
      var flv_length = tea.flavor.length;
      var flv_mode = 9%flv_length;
      var flv_direct = (9 - flv_mode) / flv_length;
      for(var i=0;i<flv_length;i++){
        flv_direct_loop = flv_direct;
        if(flv_mode != 0){
          flv_direct_loop = flv_direct + 1;
          flv_mode = flv_mode - 1;
        }
        for(var j=0;j<flv_direct_loop;j++){
          $tempStore.append($(".final_result .single_product[data-ftype='"+tea.flavor[i]+"']:first"));
        }
      }
      resultTotal = $tempStore.children().length;
      if(resultTotal > 9){
        teafinder.removeLast($tempStore);
      }
    }

    $(".final_result").html($tempStore.html());
    result_count = $(".final_result .single_product").length;
  }
  $(".result_count",parent).html(result_count);

  $(".good_to_go_wrap").show();
  parent.fadeIn();
  if ($(window).width() > 767){
    teafinder.miniHeight(".single_product .h3 ",".single_product .h3 h3");   
    teafinder.miniHeight(".single_product .content ",".single_product .content_wrap"); 
  }

  teafinder.hideLoading();
  if(!cn(form)){
    teafinder.formSubmit(form,teafinder.customerFormCallback);
  }
}
};
teafinder.removeLast = function($tempStore){
  $('.single_product:last',$tempStore).remove();
  if($tempStore.children().length > 9){
    teafinder.removeLast($tempStore);
  }
}
teafinder.goToHome = function(data){
  var gtg = $(".good_to_go");
  gtg.addClass("save_good_to_go");
  var gtg_text = $(".button_fixed_wrapper .reset_p")
  if(data){
    gtg.text("SAVED IN YOUR ACCOUNT");
    gtg_text.html("<p class='reset_p'>To view go to <a href=''> My Preference</a> under My Account</p>");
    window.location.href = "/account#wishlist";
  }
  else{
    window.localStorage.removeItem('tea');
    window.location.href  = window.location.href;
  }
};
teafinder.changeStep = function(target){
  if(target == 4 || target == '4'){
    $("body").addClass("p_bg");
    if($('.logged_customer_checker').length > 0 ){
      var logged_email = $('.logged_customer_checker').text();
      $('.customer_info .email_input').val(logged_email);
      $('.email_block .skip_email').click();
    }
  }
  else{
    $("body").removeClass("p_bg");
  }
  $(".tea_header .step").removeClass('active');
  $(".step.step_"+target).addClass('active');
  $(".section_wrapper .section").hide();
  $(".section.section_"+target).fadeIn();   
}
teafinder.storeLocal = function(){
  localStorage.setItem("tea", JSON.stringify(tea));
};
teafinder.getLocal = function(){
  return localStorage.getItem('tea');
}
teafinder.setObjData = function(){
  var location = $(".tea-store .active").attr("data-name");
  var mood = $(".mood_wrap").attr("data-selected");
  var flavor = $(".flavor_wrap").attr("data-selected");
  var drink =  $(".drinking_wrap").attr("data-selected");
  var email = $(".email_wrap").attr("data-selected");
  if(!cn(location)){
    tea.location = location;
  }
  if(!cn(mood)){
    tea.mood = mood;
  }
  if(!cn(flavor)){
    flavor = flavor.split(",");  
    tea.flavor = flavor;
  }

  if(!cn(drink)){
    tea.drink = drink;
  }
  if(!cn(email)){
    tea.email = email;
  }
  teafinder.storeLocal();
};
teafinder.autoFunctionSelect = function(value,selector){
  if(!$.isArray(value)){
    valuearray = new Array();  
    valuearray.push(value);
    value = valuearray;
  }
  var parent = null;
  for(var i=0; i<value.length;i++){
    var option = $("."+selector+" .text[data-text='"+value[i]+"']");
    var single_option = option.closest('.single_option');
    parent = single_option.closest('.section');
    single_option.click();
  }

  $(".next",parent).click();
};
teafinder.autoSelect = function(){
  if(!cn(teafinder.getLocal())){
    tea = JSON.parse(teafinder.getLocal());
  }
  try{
    teafinder.locationQuery();
    if(tea.location){
      // var location =  $(".single_store[data-name='"+tea.location+"']");
      // location.addClass('active');
      // $(".intro_page").hide();
      // $(".tea-store").hide();  
      // $(".section_wrapper").show(); 
    }

    if(tea.mood){
      $(".get_started").click();
      teafinder.autoFunctionSelect(tea.mood,"mood_wrap");
    }
    if(tea.flavor){
      var flavors = tea.flavor;
      teafinder.autoFunctionSelect(flavors,"flavor_wrap");

    }
    if(tea.drink){
      teafinder.autoFunctionSelect(tea.drink,"drinking_wrap"); 
    }
    if(tea.email){
      teafinder.showResult();
    }
  }
  catch(e){
    console.log(e);
  }
};
teafinder.showLoading = function(text){

  $("body").addClass('overflow_hidden');
  $("html").addClass('overflow_hidden');

  if(cn(text)){
    $(".loading_me p").hide();
  }
  else{
    $(".loading_me p").show(); 
  }
  teafinder.showHeader();
  $(".loading_me").fadeIn();
};
teafinder.hideLoading = function(){
  $("body").removeClass('overflow_hidden');
  $("html").removeClass('overflow_hidden');
  $(".loading_me").hide();
};
teafinder.formSubmit = function (selector, callback) {//Ajax Submit Form 
  var form = selector;
  if (form.length > 0) {
    var url = form.attr("action");
    var params = {
      type: 'POST',
      url: url,
      data: form.serialize(),
      success: function (line_item) {
        try {
          var data = JSON.parse(line_item);
        } catch (e) {
          var data = line_item;
        }
        if(!cn(callback)){
          teafinder.hideLoading();
          callback(data);  
        }

      },
      error: function (XMLHttpRequest, textStatus) {
        teafinder.hideLoading();
        callback(); 
      }
    };
    jQuery.ajax(params);
  }
};
teafinder.queryString = function(){
  var vars = {};
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for(var i = 0; i < hashes.length; i++)
  {
    var hash = hashes[i].split('=');
    var obj = {};
    obj.name = decodeURI(hash[0]);
    obj.value = decodeURI(hash[1]);
    vars[obj.name] = obj;
  }
  return vars;
};

teafinder.customerFormCallback = function(data){
  teafinder.hideLoading();

};
teafinder.miniHeightAction =  function(selector){
  var min_height=0; 
  selector.each(function(){
    var height=$(this).outerHeight();
    if(height>min_height){
      min_height=height;
    }
  });
  return min_height;
};


teafinder.miniHeight = function(parent,select){


  var parentWrapper = $(parent).closest(".shopify-section");
  parentWrapper.each(function(index,item){
    if($(parent,item).length > 0){
      var result=teafinder.miniHeightAction($(select,item));
      $(parent,item).css("height",result);
    }
  });

};

teafinder.ajaxCart =  function(form,button){
  button.html("<img src='https://cdn.shopify.com/s/files/1/1865/1011/files/loading-img.gif?123617' class='product-animation' />");
  var qty = $("#Quantity",form).val();
  var data = form.serialize();
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(line_item) {
      button.text("Secure Checkout");
      button.removeAttr( "onclick" );
      button.click(function(){
        button.attr("type","button");
        button.html("<img src='https://cdn.shopify.com/s/files/1/1865/1011/files/loading-img.gif?123617' class='product-animation' />");
        setTimeout(function(){
          window.location.href = "/checkout";
        }, 200);
      });
      $.get("/cart?view=quick",function(data){
        data = $(data);
        var count = $(".cart_count",data).text();
        $("#cart-length-sp").removeClass("cart_grey").addClass("cart_green").text(count);
        var cart_drawer = $("#cart_drawer",data);
        $("#cart_drawer").html(cart_drawer.html());
      });
    },
    error: function(XMLHttpRequest, textStatus) {
      var error=  JSON.parse((XMLHttpRequest.responseText)).description;
      console.log(error);
    }
  };
  jQuery.ajax(params);
};

teafinder.hoverEvent = function(){};
teafinder.changeEvent = function(){};
teafinder.submitEvent = function(){
  $(".customer_info").submit(function(e) {
    e.preventDefault();
    var email_input =  $(".email_input",this);
    var email_address = email_input.val();

    if(cn(email_address)){
      email_input.focus();
      email_input.addClass('error');
      email_input.attr("placeholder","Email address required");
    }
    else{

      email_input.removeClass('error');
      email_input.attr("placeholder","Enter your email address");
      var jsonData = JSON.stringify(tea);
      $(".customer_choice").val(jsonData);
      $(".email_wrap").attr("data-selected",email_address);
      teafinder.setObjData();
      teafinder.showResult($(this));

    }
  });
  $(".customer_info_popup").submit(function(e) {
    e.preventDefault();
    var email_input =  $(".email_input",this);
    var email_address = email_input.val();

    if(cn(email_address)){
      email_input.focus();
      email_input.addClass('error');
      email_input.attr("placeholder","Email address required");
    }
    else{

      email_input.removeClass('error');
      email_input.attr("placeholder","Enter your email address");
      var jsonData = JSON.stringify(tea);
      $(".customer_choice").val(jsonData);
      $(".email_wrap").attr("data-selected",email_address);
      teafinder.setObjData();
      // teafinder.goToHome();
      $(".good_to_go").click();

    }
  });

  $(document).on("submit",".ajaxCart",function(e){
    e.preventDefault();
    var form = $(this);
    var button = $(".buy_me",form);
    teafinder.ajaxCart(form,button);
  });

}; 
teafinder.locationQuery = function(){
  var query = teafinder.queryString();
  if(!cn(query)){
    if(query.location){
      var my_location = query.location.value;

    }
    if(query.event){
      var event_loca = query.event.value;
    }
    try{
      ;
      tea.location = location_map[my_location][event_loca];
      teafinder.storeLocal();
    }
    catch(e){
      console.log(e);
    }

  }
};
teafinder.load = function(){
  $(window).resize(function(){
    if ($(window).width() == teafinder.current_width) {
      return;
    }
    if ($(window).width() > 767){
      teafinder.miniHeight(".single_product .h3 ",".single_product .h3 h3");   
      teafinder.miniHeight(".single_product .content ",".single_product .content_wrap"); 
    }
  });
  if($("#shopify-section-tea-intro .intro_page").length > 0){
    $("html").addClass("no-pad-intro-page");
  }
};

teafinder.productSwatchesInit = function(parent){
  if($("#quick_view .swatches").length > 0){
    parent.find(".single-option-selector").each(function(index,item){
      var value = $(item).val();
      var target = $(item).attr("data-option");
      target = target.replace("option","");
      target = parseInt(target) - 1;
      var select = parent.find(".swatch[data-option-index='"+target+"']");
      select.find(".swatch-element[data-value='"+value+"']").addClass("active");
    });

    parent.find(".swatches").each(function(){
      if($(this).find(".swatch-element").length < 2){
        $(this).hide();
      }
    });
    if($("#product_page .hide_sold_out").length > 0){
      teafinder.linkOptionSelectors(teafinder.productJson);
    }
  }
};

teafinder.linkOptionSelectors = function(product) {
  var product_id = product.id;
  var parent = $(".card_"+product_id);
  // Building our mapping object.
  var optionsMap = {};
  teafinder.productoptionsMap[product_id] = optionsMap;
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      optionsMap['root'] = optionsMap['root'] || [];
      optionsMap['root'].push(variant.option1);
      optionsMap['root'] = Shopify.uniq(optionsMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        optionsMap[key] = optionsMap[key] || [];
        optionsMap[key].push(variant.option2);
        optionsMap[key] = Shopify.uniq(optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        optionsMap[key] = optionsMap[key] || [];
        optionsMap[key].push(variant.option3);
        optionsMap[key] = Shopify.uniq(optionsMap[key]);
      }
    }
  }
  // Update options right away.
  teafinder.updateOptionsInSelector(0, product_id);
  if (product.options.length > 1) teafinder.updateOptionsInSelector(1,product_id);
  if (product.options.length === 3) teafinder.updateOptionsInSelector(2, product_id);
  // When there is an update in the first dropdown.
  parent.find(".single-option-selector:eq(0)").change(function() {
    teafinder.updateOptionsInSelector(1, product_id);
    if (product.options.length === 3) teafinder.updateOptionsInSelector(2, product_id);
    return true;
  });
  // When there is an update in the second dropdown.
  parent.find(".single-option-selector:eq(1)").change(function() {
    if (product.options.length === 3) teafinder.updateOptionsInSelector(2, product_id);
    return true;
  });  
};
teafinder.productVariantInitialize = function(){
  if(!cn(teafinder.productJson)){
    var selectProductId = "ProductSelect_"+teafinder.productJson.id;
    if($('#'+selectProductId).length > 0){
      var callBack = window["selectCallback_"+teafinder.productJson.id];
      new Shopify.OptionSelectors(selectProductId, {
        product: teafinder.productJson,
        onVariantSelected: callBack ,
        enableHistoryState: true
      });
      var parent = $(".card_"+teafinder.productJson.id);
      //       teafinder.productSelectHide();
      teafinder.productSwatchesInit(parent);
      $("#product_card .selector-wrapper select").each(function(index,item){
        if($(item).children().length > 1){
          $(item).parent().show();
        }
        else{
          $(item).parent().hide();
        }
      });
    };
  }
};

teafinder.product_page_slider = function(selector){
  selector.flexslider({
    animation: "slide",
    itemWidth: 380,
    slideshow: false
  });
};

teafinder.productCallback = function (options) {
  var moneyFormat = options.money_format,
  variant = options.variant,
  selector = options.selector,
  translations = options.translations;
  // Selectors
  var parent_id = $('#'+options.selector.domIdPrefix).data('productid');
  var parent = $(".card_"+parent_id);
  var $addToCart = parent.find('#AddToCart'),
  $productPrice = parent.find('#ProductPrice'),
  $comparePrice = parent.find('#ComparePrice'),
  $inventory = parent.find("#ProductInventory"),
  $quantityElements = parent.find('.js-quantity-selector, label + .js-qty'),
  $product_img = parent.find("#ProductImages");
  $addToCartText = parent.find('#AddToCartText');
  if(cn(teafinder.product_page_slider)){
    teafinder.initProductSlider();
  }
  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_image) {
      var imgObj = variant.featured_image;
      var new_img = imgObj.id;
      new_img = ".id_"+new_img;
      var index = $product_img.find(new_img).attr("data-index");
      if(!cn(index)){
        index = parseInt(index) - 1;
        teafinder.product_page_slider.goToSlide(index);
      }
    }
    for (var i=0,length=variant.options.length; i<length; i++) {
      var option = variant.options[i];
      var swatch = $('.swatch-element[data-value="'+option+'"]', parent);
      teafinder.productSwatchesChange(swatch, false);
    }
    // Select a valid variant if available
    if (variant.available) {
      if(!cn(variant.inventory_management)){
        $inventory.html(variant.inventory_quantity +" "+translations.inStock);
      }
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(translations.addToCart);
      $quantityElements.show();
      $quantityElements.attr("disabled",false);
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(translations.soldOut);
      $quantityElements.attr("disabled",true);
      if(!cn(variant.inventory_management)){
        $inventory.html("");
      }
    }
    $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat).replace(/((\,00)|(\.00))$/g, '')).show();
    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
      $productPrice.addClass('on-sale');
    } else {
      $productPrice.removeClass('on-sale');
      $comparePrice.html("");
    }
  } 
  else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $comparePrice.html("");
    $addToCartText.html(translations.unavailable);
    $quantityElements.attr("disabled",true);
  }
  selectCallback();
};
window.selectCallback = teafinder.selectCallback = function(){

}
teafinder.productSwatchesChange = function(selector, trigger){
  selector.siblings().removeClass("active");
  selector.addClass("active");
  $(".image_block .addbutton").each(function(index, el) {
    $(el).remove();
  });
  $(".add_to_cart").html("Add to Cart");
  if(trigger){
    var target = selector.attr("data-value");
    var parent = selector.parent();
    var product = parent.attr("data-id");
    var oi = parent.attr("data-option-index");
    oi = parseInt(oi) + 1;
    oi = "option"+oi;
    var select = $("."+product).find(".single-option-selector[data-option='"+oi+"']");
    select.val(target).trigger('change');
  }
};

teafinder.positionGoodToGo = function(){
  if($(".no_data").css("display") == "none"){
    $(".button_fixed_wrapper").css("position","relative");
    $(".button_fixed_wrapper").css("padding-top","15px");
  }
};

teafinder.getCookie = function (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
teafinder.setCookie = function(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};


window.selectCallback = teafinder.selectCallback = function(){

}
teafinder.init = function(){
  teafinder.clickEvent();
  teafinder.hoverEvent();
  teafinder.changeEvent();
  teafinder.submitEvent();
};
$(document).ready(function(){
  teafinder.current_width = $(window).width();
  window.tea = {};


  window.tempFlvor=[];
  $(".loading_me").appendTo('body');
  teafinder.init();
  // teafinder.autoSelect();
  teafinder.load();
  teafinder.positionGoodToGo();
});